export const uploadThumbnailToS3 = ({
  uploadUrl,
  file,
  onProgress = () => {},
}) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.open("PUT", uploadUrl);
    xhr.setRequestHeader("Content-Type", file.type);

    xhr.upload.onprogress = (event) => {
      if (!event.lengthComputable) return;

      const percent = Math.round((event.loaded / event.total) * 100);
      onProgress(percent);
    };

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(true);
        return;
      }

      reject(new Error(`S3 upload failed with status ${xhr.status}`));
    };

    xhr.onerror = () => {
      reject(new Error("S3 upload failed"));
    };

    xhr.send(file);
  });
};
